export default __webpack_public_path__ + "media/chemistry.927b1f67e7ed25d1b394b25ef104cc31.webp";